import { getSiteConfig } from '../../siteConfig';

export const formatDate = (
  d,
  options = { year: 'numeric', month: 'numeric', day: 'numeric' },
) => {
  return new Date(d).toLocaleDateString(getSiteConfig().locale, options);
};

export const formatTime = (
  t,
  options = { hour: 'numeric', minute: 'numeric' },
) => {
  return new Date(t).toLocaleTimeString(getSiteConfig().locale, options);
};

export const getDuration = (timeSpan) => {
  if (timeSpan == null) return null;

  const spans = timeSpan.split(':');
  const hours = spans[0];
  const minutes = spans[1];

  return `${parseInt(hours) !== 0 ? parseInt(hours) + ' h' : ''}${
    parseInt(minutes) !== 0 ? ' ' + parseInt(minutes) + ' m' : ''
  }`;
};

export const getWeek = (inputDate) => {
  var date = new Date(inputDate);
  date.setHours(0, 0, 0, 0);
  // Thursday in current week decides the year.
  date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
  // January 4 is always in week 1.
  var week1 = new Date(date.getFullYear(), 0, 4);
  // Adjust to Thursday in week 1 and count number of weeks from date to week1.
  return (
    1 +
    Math.round(
      ((date.getTime() - week1.getTime()) / 86400000 -
        3 +
        ((week1.getDay() + 6) % 7)) /
        7,
    )
  );
};

export const getWeekDayShort = (inputDate) => {
  var date = new Date(inputDate);
  return `${date.toLocaleDateString(getSiteConfig().locale, {
    weekday: 'short',
  })}. `;
};

// Returns the four-digit year corresponding to the ISO week of the date.
export const getWeekYear = (outDate, homeDate) => {
  var date = new Date(outDate);
  date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
  const out = date.getFullYear();

  var date2 = new Date(homeDate);
  date2.setDate(date2.getDate() + 3 - ((date2.getDay() + 6) % 7));
  const home = date2.getFullYear();

  return out === home ? out : `${out}/${home}`;
};

export const getMonth = (inputDate) => {
  var date = new Date(inputDate);
  return date.getMonth() + 1;
};

export const getDay = (inputDate) => {
  var date = new Date(inputDate);
  return date.getDate();
};

export const getDateString = (dateOut, dateHome, showDayName) => {
  const { locale } = getSiteConfig();
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  const dateOutObj = new Date(dateOut);
  const dateHomeObj = new Date(dateHome);

  if (dateOutObj.getMonth() === dateHomeObj.getMonth()) {
    if (dateOutObj.getFullYear() === dateHomeObj.getFullYear()) {
      return `${
        showDayName ? getWeekDayShort(dateOutObj) : ''
      }${dateOutObj.getDate()} - ${
        showDayName ? getWeekDayShort(dateHomeObj) : ''
      }${dateHomeObj.getDate()} ${dateOutObj.toLocaleDateString(locale, {
        month: 'long',
      })} ${dateOutObj.getFullYear()}`;
    } else {
      return `${
        showDayName ? getWeekDayShort(dateOutObj) : ''
      }${dateOutObj.getDate()} ${dateOutObj.toLocaleDateString(locale, {
        month: 'long',
      })} ${dateOutObj.getFullYear()} - ${
        showDayName ? getWeekDayShort(dateHomeObj) : ''
      }${dateHomeObj.getDate()} ${dateHomeObj.toLocaleDateString(locale, {
        month: 'long',
      })} ${dateHomeObj.getFullYear()}`;
    }
  } else {
    return `${
      showDayName ? getWeekDayShort(dateOutObj) : ''
    }${dateOutObj.toLocaleDateString(locale, {
      day: 'numeric',
      month: 'long',
    })} - ${
      showDayName ? getWeekDayShort(dateHomeObj) : ''
    }${dateHomeObj.toLocaleDateString(locale, options)}`;
  }
};

export const getSeason = (dateOut, dateHome) => {
  const dateOutObj = new Date(dateOut);
  const dateHomeObj = new Date(dateHome);
  const dateDiff = (dateHomeObj - dateOutObj) / (1000 * 60 * 60 * 24);

  const isSummer = dateOutObj.getMonth() >= 4 && dateOutObj.getMonth() <= 9;
  const isJulbord =
    dateOutObj.getMonth() === 10 ||
    (dateOutObj.getMonth() === 11 &&
      dateOutObj.getDate() <= 24 &&
      dateDiff < 5);

  if (isSummer) {
    return `Summer ${dateOutObj.getFullYear()}`;
  } else if (isJulbord) {
    return `Julbord ${dateOutObj.getFullYear()}`;
  } else {
    return `Winter ${
      dateOutObj.getMonth() === 11
        ? `${dateOutObj.getFullYear()}/${dateOutObj.getFullYear() + 1}`
        : `${dateOutObj.getFullYear() - 1}/${dateOutObj.getFullYear()}`
    }`;
  }
};

export const combinePeriodsOnWeek = (periods) => {
  const periodsWithWeek = periods.map((p) => {
    return {
      ...p,
      week: getWeek(p.home),
    };
  });

  const combinedPeriods = periodsWithWeek.reduce((acc, curr) => {
    //TODO: do not combine periods shorter than 6 days
    const dateDiff =
      (new Date(curr.home) - new Date(curr.out)) / (1000 * 60 * 60 * 24);

    const existing = acc.find((p) => p.week === curr.week);
    if (existing && dateDiff > 6) {
      existing.out =
        new Date(existing.out) < new Date(curr.out) ? existing.out : curr.out;
      existing.outTo =
        new Date(existing.outTo) > new Date(curr.out)
          ? existing.outTo
          : curr.out;

      existing.home =
        new Date(existing.home) > new Date(curr.home)
          ? existing.home
          : curr.home;

      existing.homeFrom =
        new Date(existing.homeFrom) < new Date(curr.home)
          ? existing.homeFrom
          : curr.home;
    } else {
      acc.push({
        out: curr.out,
        outTo: curr.out,
        home: curr.home,
        homeFrom: curr.home,
        week: curr.week,
      });
    }
    return acc;
  }, []);

  combinedPeriods.sort((a, b) => new Date(a.out) - new Date(b.out));

  return combinedPeriods;
};
